import { Chevron, type DirectionType } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  direction: DirectionType
}

const ExpandButton = (props: Props) => {
  const { direction } = props

  return (
    <div className={'ExpandButton_expandButton'}>
      <Chevron type="terciary" direction={direction} />
    </div>
  )
}

export default ExpandButton
